import { CartSliceState } from '@/store/cartSlice/type.ts'

export const selectActiveElementQuotedSeatsAmount = (state: CartSliceState) => {
  const { b, c, d, m } = state.selectedElementQuotableProducts
  return [b, c, d, m].reduce((acc, item) => {
    acc = acc + item
    return acc
  })
}
